/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import BYADWrapper from './components/BYADWrapper';
import { AzureADWrapper } from './components/AzureADWrapper';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import 'react-grid-layout/css/styles.css';
import './index.css';
import { store } from './store/configureStore';
import { userReducerInitialState } from './store/user/userReducer';
import { FeatureFlagsProvider } from '@jda/lui-portal-utilities';
import { isPortalV2 } from './utility/commonUtility';

const { HARNESS_FF_API_KEY } = window['env'];

const initialState = {
  user: userReducerInitialState,
  loader: {},
  error: {},
  auth: {},
  snackBar: {
    snackBarMessage: {
      showSnackbar: false,
      autoHideDuration: 5000,
      message: '',
      severity: ''
    }
  }
};

const AuthWrapper = isPortalV2() ? BYADWrapper : AzureADWrapper;

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <AuthWrapper>
    <Provider store={store(initialState)}>
      <Router>
        <FeatureFlagsProvider apiKey={HARNESS_FF_API_KEY}>
          <App />
        </FeatureFlagsProvider>
      </Router>
    </Provider>
  </AuthWrapper>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


